import React, { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { EMPTY_IMAGE, Typography } from '../../../components/common';
import { Table } from '../table';
import { getRowProps } from '../table/tableHelpers';

const InstancesTable = ({ instances, isLoading }) => {
    const [hoveredRow, setHoveredRow] = useState(null);
    const history = useHistory();

    function CompanyCell({ value, column, row }) {
        return (
            <div className="flex items-center">
                <div className="flex-shrink-0 h-10 w-10 align-middle content-center grid">
                    <img
                        className="max-h-10 max-w-10 align-middle content-evenly m-auto"
                        src={`data:image/png;base64,${value || EMPTY_IMAGE.base64}`}
                        alt={row.original[column.companyAccessor]}
                    />
                </div>
                <div className="ml-4">{row.original[column.companyAccessor]}</div>
            </div>
        );
    }

    const columns = useMemo(
        () => [
            {
                Header: 'Company',
                accessor: 'logo',
                companyAccessor: 'company',
                Cell: CompanyCell,
            },
            {
                Header: 'Project',
                accessor: 'project',
            },
        ],
        []
    );

    const onRowClick = (row) => history.push(`/instance/${row.original.instanceid}`);

    if (!isLoading && (!instances || !instances.length)) {
        return (
            <Typography variant="body2">
                You do not have access to any Connect instances.
            </Typography>
        );
    }

    return (
        <div className="instances-table">
            <Table
                isLoading={isLoading}
                getRowProps={(row) => getRowProps(row, onRowClick, hoveredRow, setHoveredRow)}
                columns={columns}
                data={instances}
                filterable={false}
            />
        </div>
    );
};

export default InstancesTable;
